import { TEACHER_ACTIVITY_TYPE_ID } from '@/dictionary';

/**
 * Конструктор уроков (список, создание, редактирование) доступен только
 * авторизованному пользователю с ролью учителя.
 *
 * Просмотр отдельного урока открыт всем: на страницу урока ведёт QR-код,
 * который сканируют ученики.
 */
export const useLessonAccess = () => {
  const { isAuthorized } = storeToRefs(useAuthStore());
  const { userData } = useUserData();

  const canEditLessons = computed(() => {
    if (!isAuthorized.value) return false;

    return userData.data?.value?.activity_type_id === TEACHER_ACTIVITY_TYPE_ID;
  });

  return {
    canEditLessons,
  };
};
